<div class="card">
  <div class="card-header">
    <h4 class="card-title float-left" id="basic-layout-form">{{ 'companies.title' | translate }}</h4>
    <div class="clear-float-left"></div>
    <br>
    <button [hidden]="!sectionPermission.CanAdd" class="btn btn-raised btn-primary float-right" (click)="openModal()">
      <i
        class="ft-plus-circle"></i> {{ hasDesktopView ? ('companies.addNewButtonText' | translate) : ('buttons.newText' | translate) }}
    </button>
    <input type='text' class="form-control form-control-sm filter-input"
           placeholder="{{'companies.filterByNamePlaceHolder' | translate}}" (keyup)='searchFilter($event)'/>
    <app-boolean-toggle-filter class="d-none d-md-block filter-input"
                               [booleanToggleFilterText]="'companies.showInActiveText' | translate"
                               (booleanToggleFilterChangedEvent)="handleBooleanToggleFilterChanged($event)"></app-boolean-toggle-filter>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
          <th>{{ 'companies.actionsFieldTitle' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let company of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <ng-template [ngIf]="company.IsActive">
            <td><i class="circle bg-green"></i></td>
          </ng-template>
          <ng-template [ngIf]="!company.IsActive">
            <td><i class="circle bg-red"></i></td>
          </ng-template>
          <td class="d-none d-lg-table-cell">{{ company.CompanyId }}</td>
          <td class="col-sm-5 col-5">{{ company.Name }}</td>
          <td class="d-none d-lg-table-cell">{{ company.IBAN }}</td>
          <td class="d-none d-sm-table-cell">{{ company.CreditAmountCurrency }}</td>
          <td>
            <a *ngIf="!openOnboardingUrlButtonDisabled(company)" class="warning" data-original-title=""
               title="{{'companies.openOnboardingUrlTitle' | translate: company}}" (click)="openOnboardingUrl(company)">
              <i class="ft-link font-medium-3 mr-1"></i>
            </a>
            <i [ngClass]="company.OnboardingStatus.IconClass" title="{{company.OnboardingStatus.Hint}}"></i>
          </td>
          <td>
            <a *ngIf="sectionPermission.CanEdit" class="success" data-original-title=""
               title="{{'companies.editCompanyTitle' | translate: company}}" (click)="openEditModal(company)">
              <i class="ft-edit-2 font-medium-3"></i>
            </a>
            <a *ngIf="sectionPermission.CanActivate && !company.IsActive" class="succes" data-original-title=""
               title="{{'companies.activateCompanyTitle' | translate: company}}" (click)="activate(company)">
              <i class="ft-check font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="sectionPermission.CanDeactivate && company.IsActive" class="danger" data-original-title=""
               title="{{'companies.deactivateCompanyTitle' | translate: company}}" (click)="deactivate(company)">
              <i class="ft-eye-off font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="hasFinancialTransactionsViewPermission" class="info" data-original-title=""
               title="{{'companies.viewFinancialTransactionsTitle' | translate: company}}"
               (click)="viewFinancialTransactions(company)">
              <i class="icon-credit-card font-medium-3 ml-1"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
